import { AspectRatio, cn, Skeleton } from '@mntn/ui-components'
import type { LayoutType } from './order-card'

type OrderCardSkeletonProps = {
  className?: string
  isAudience?: boolean
  layout?: LayoutType
  /**
   * @todo remove and  use layout instead
   */
  compact?: boolean

  isInverse?: boolean
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const OrderCardSkeleton: React.FC<OrderCardSkeletonProps> = ({
  className,
  layout = 'column',
  compact = false,
  isInverse = false,
}) => {
  if (layout === 'row') {
    return <OrderCardRowSkeleton isInverse={isInverse} />
  }

  return (
    <div className={className}>
      <div
        className={cn(
          'rounded-[0.25rem] flex flex-col w-full p-4 gap-2 min-h-[11.75rem] min-w-[15.75rem]',
          isInverse ? 'bg-background-inverse' : 'bg-background',
        )}
      >
        {layout !== 'compact' && !compact && (
          <div className="w-full">
            <AspectRatio ratio={4 / 5}>
              <Skeleton className="w-full h-full" dark={isInverse} />
            </AspectRatio>
          </div>
        )}
        <div className="flex flex-col gap-1">
          {(layout !== 'compact' || !compact) && <Skeleton className="h-5 w-24" dark={isInverse} />}
          <Skeleton className="h-[20px] w-3/4" dark={isInverse} />
          <Skeleton className="h-5 w-1/2" dark={isInverse} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-[15px] w-20" dark={isInverse} />
          <Skeleton className="h-2 w-full" dark={isInverse} />
          <Skeleton className="h-4 w-3/4" dark={isInverse} />
        </div>
        <Skeleton className="h-10 w-full" dark={isInverse} />
      </div>
    </div>
  )
}

const OrderCardRowSkeleton = ({ isInverse = false }) => {
  return (
    <div
      className={cn(
        'border flex w-full p-6 h-[9.375rem] items-center',
        isInverse ? 'bg-background-inverse border-border-inverse' : 'bg-background border-border',
      )}
    >
      <div className="flex flex-col gap-4 w-full relative">
        <Skeleton className="h-4 w-[6.25rem] absolute top-0 right-0 rounded-full" dark={isInverse} />
        <Skeleton className="h-4 w-2/3" dark={isInverse} />
        <Skeleton className="h-2 w-full" dark={isInverse} />
        <Skeleton className="h-4 w-1/10" dark={isInverse} />
      </div>
    </div>
  )
}
